export default {
  // 定制服务首页
  homeSettings: {},
  // 首页城市
  homeCity: {},
  // 是否正在定位flag
  locating: false,
  // 定位城市
  locateCity: {}
}
